<template>
  <div class="item-added">
    <p class="dynamicTagslight truncate-line mw-100" :class="{ 'tag-selected' : selected }" @click="emitTagClick">
      {{text}}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    dataClass: String,
    text: String,
    selected: Boolean
  },
  methods: {
    emitTagClick() {
      this.$emit('onTagClick', this.value);
    }
  }
};
</script>

<style scoped>
.item-added {
  width: max-content;
  max-width: 100%;
  float: left;
  margin-right: 6px;
  margin-top: 10px;
  color: white;
  cursor: pointer;
}

.item-added p {
  font-weight: 600;
  line-height: 12px;
  text-align: left;
  margin: 0;
  display: inline-block;
}
.item-added .dynamicTagsdark {
  background-color: #1b2342;
  color: white;
  padding: 8px !important;
  font-size: 10px;
}
.item-added .dynamicTagslight {
  padding: 9px 15px !important;
  background-color: white;
  color: #1b2342;
  font-size: 14px;
}

.item-added p i {
  font-size: 10px !important;
  margin: 0 !important;
  line-height: 1.1 !important;
  color: white;
}
.tag-selected {
  background: #7440fb !important;
  color: #fff !important;
}

</style>


